import React, { createContext, useState, useContext } from 'react';
import posthog from 'posthog-js';
import { ROUND_TRIP_MODE_VALUE } from 'app/constants';

export const SearchResultsPageContext = createContext({
  search_button_click_timestamp: null,
  is_search_edited: false,
  handleSearch: () => {},
});

export const useSearchResultsPageContext = () => useContext(SearchResultsPageContext);

export const SearchResultsPageProvider = ({ children }) => {
  const [{ search_button_click_timestamp, is_search_edited }, setState] =
    useState({
      search_button_click_timestamp: performance.now(),
      is_search_edited: false,
    });

  const handleSearch = (time, data) => {
    posthog.capture('Edit Search Form Submitted', {
      start_address: data.start_address.display,
      start_address_type: data.start_address.type,
      end_address: data.end_address?.display,
      end_address_type: data.end_address?.type,
      pickup_time: data.pickup_datetime.format('HH:mm:ss'),
      pickup_date: data.pickup_datetime.format('YYYY-MM-DD'),
      is_landing_time_selected: data.is_flight_time,
      passenger_count: data.num_passengers,
      is_return_added: data.mode === ROUND_TRIP_MODE_VALUE,
      return_pickup_date: data.return_pickup_datetime?.format('YYYY-MM-DD'),
      return_pickup_time: data.return_pickup_datetime?.format('HH:mm:ss'),
      is_return_landing_time_selected: data.is_return_flight_time,
    });

    setState((prevState) => {
      return {
        ...prevState,
        search_button_click_timestamp: time,
        is_search_edited: true,
      };
    });
  };

  return (
    <SearchResultsPageContext.Provider
      value={{ search_button_click_timestamp, is_search_edited, handleSearch }}
    >
      {children}
    </SearchResultsPageContext.Provider>
  );
};
